import React from 'react';
import { Video, Calendar, Users, ExternalLink } from 'lucide-react';

const meetings = [
  {
    id: 1,
    title: 'Technical Review Meeting',
    date: '2024-03-15',
    time: '10:00 AM',
    attendees: [
      { name: 'Sarah Johnson', avatar: 'https://ui-avatars.com/api/?name=Sarah+Johnson' },
      { name: 'Michael Chen', avatar: 'https://ui-avatars.com/api/?name=Michael+Chen' },
    ],
    link: 'https://meet.google.com/abc-defg-hij',
  },
  {
    id: 2,
    title: 'Proposal Strategy Session',
    date: '2024-03-16',
    time: '2:00 PM',
    attendees: [
      { name: 'Emily Rodriguez', avatar: 'https://ui-avatars.com/api/?name=Emily+Rodriguez' },
      { name: 'David Kim', avatar: 'https://ui-avatars.com/api/?name=David+Kim' },
    ],
    link: 'https://meet.google.com/xyz-uvwx-yz',
  },
];

export function UpcomingMeetings() {
  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium text-gray-900">Upcoming Meetings</h2>
        <button className="text-sm font-medium text-purple-600 hover:text-purple-500">
          Schedule Meeting
        </button>
      </div>

      <div className="mt-6 space-y-4">
        {meetings.map((meeting) => (
          <div
            key={meeting.id}
            className="flex items-center justify-between rounded-lg border border-gray-200 bg-white p-4"
          >
            <div className="flex items-center space-x-4">
              <div className="rounded-lg bg-purple-100 p-3">
                <Video className="h-5 w-5 text-purple-600" />
              </div>
              <div>
                <h3 className="font-medium text-gray-900">{meeting.title}</h3>
                <div className="mt-1 flex items-center space-x-2 text-sm text-gray-500">
                  <Calendar className="h-4 w-4" />
                  <span>{meeting.date} at {meeting.time}</span>
                </div>
                <div className="mt-2 flex -space-x-2">
                  {meeting.attendees.map((attendee) => (
                    <img
                      key={attendee.name}
                      src={attendee.avatar}
                      alt={attendee.name}
                      className="h-6 w-6 rounded-full ring-2 ring-white"
                      title={attendee.name}
                    />
                  ))}
                </div>
              </div>
            </div>
            <a
              href={meeting.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-lg bg-purple-600 px-3 py-2 text-sm font-medium text-white hover:bg-purple-700"
            >
              <ExternalLink className="mr-2 h-4 w-4" />
              Join Meeting
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}